import './App.css';
import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Home from './pages/home/home'
import Blog from './pages/blog/Blog';
import SignIn from './pages/sign-in/SignIn'
import PrivacyPolicy from './pages/legal/privacyPolicy/privacyPolicy';
import TermsOfUse from './pages/legal/termsOfUse/termsOfUse';
import Success from './pages/success/Success';
import SuccessInfo from './pages/success/SuccessInfo';
import {cyan} from '@mui/material/colors'
import { ThemeProvider, createTheme } from '@mui/material/styles';

  const theme = createTheme({
    palette: {
      primarykk: cyan
    }
  })

function App() {

  return (
    <ThemeProvider theme={theme}>
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/blog" element={<Blog />} />
      <Route path="/sign-in" element={<SignIn />} />
      <Route path="/success" element={<Success />} />
      <Route path="/success-info" element={<SuccessInfo />} />
      <Route path="/legal/terms-of-use" element={<TermsOfUse />} />
      <Route path="/legal/privacy-policy" element={<PrivacyPolicy />} />
    </Routes>
    </ThemeProvider>
  );
}

export default App;
